import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "../i18n/en";
import cs from "../i18n/cs";

i18n
  .use(initReactI18next)
  .init({
    fallbackLng: "en",
    lng: "cs",
    interpolation: {
      escapeValue: false,
    },
    resources: {
      en: { translation: en },
      cs: { translation: cs },
    },
  });

export default i18n;
